import React from 'react';
import PropTypes from 'prop-types';
import UnstyledHeading from '@shared/unstyled-heading';
import '../../../../../forms/forms.scss';

const Title = ({ tab }) => (
  <div styleName="form-title" id={`tab-section-${tab.id}-title`}>
    <UnstyledHeading rank={3} routeFocusSkip styleName="form-title-label">
      {tab.label}
    </UnstyledHeading>
    {tab.extra && (
      <div styleName="form-title-label-extra">
        {tab.extra}
      </div>
    )}
  </div>
);

Title.propTypes = {
  tab: PropTypes.object
};

export default Title;
